import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ao4l4qmrrd: FaireBrandEntity = {
  token: "b_ao4l4qmrrd",
  type: "brand",
  name: "Sun's Out!",
  avatarUrl: "https://cdn.faire.com/fastly/fd0be98b3e788b7d6fbfc0df7faff47112b1ce0e5519f3a98798f81a3912a4ab.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/78a5771e3d92ba42bac256433787bb6ed68a67bd4576eb08024923f4ffe1b9a7.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/fd0be98b3e788b7d6fbfc0df7faff47112b1ce0e5519f3a98798f81a3912a4ab.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/78a5771e3d92ba42bac256433787bb6ed68a67bd4576eb08024923f4ffe1b9a7.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 139,
  isTopShop: true,
  isInsider: true,
  description: "Sun’s Out! specializes in unique, upcycled, and one-of-a-kind secondhand fashion that celebrates summer. Our collection is designed to offer eco-conscious, stylish options that stand out, helping you bring something truly special to your audience. \nPartner with us at thesunsout.com \n\n\n\n\n\n ",
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:11:42.432Z",
    importedBy: "entity-db-cli"
  }
};
